import { toast } from 'react-toastify'

export function handleError(params) {
    let error =
        Array.isArray(params) && params.includes('msg')
            ? JSON.parse(params)
            : params
    return toast.error(error.msg ? error.msg : params)
}
